// extracted by mini-css-extract-plugin
module.exports = {"fond":"Fond_fond__10gGo","hidden":"Fond_hidden__1_rQ1"};